import { type FC, useMemo } from "react";

import { Form, type FormProps } from "../form";
import { GridFormProvider } from "./grid-form-provider";
import { type GridData, GridFormSchema, type GridFormValues } from "./use-grid-form";

export interface GridFormProps extends FormProps<GridFormValues, typeof GridFormSchema> {
  data: GridData;
}

export const GridForm: FC<GridFormProps> = ({ children, data, ...props }) => {
  const defaultValues = useMemo(
    () => ({
      rowIds: [] as string[],
      rowIdsSelectAll: false,
    }),
    []
  ) as GridFormValues;

  return (
    <Form<GridFormValues, typeof GridFormSchema>
      validationSchema={GridFormSchema}
      defaultValues={defaultValues}
      {...props}
    >
      <GridFormProvider data={data}>{children}</GridFormProvider>
    </Form>
  );
};
